

























































































import {
  CentralNotificacoesService,
  FiltroCentralNotificacoes,
  Notificacao,
  TipoEnvioNotificacao,
} from "@/services/central-notificacao.service";
import Confirm from "@/shared/components/confirm.vue";
import DataTable from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import { dateTime, publicoNotificacao, statusNotificacao } from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { ServerPageOptions } from "@/shared/utils/datatable";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import ComboTipoEnvioNotificacao from "./ComboTipoEnvioNotificacao.vue";
import ComboTipoNotificacao from "./ComboTipoNotificacao.vue";
import Detalhes from "./DetalhesEventoRow.vue";
import Manter from "./Manter.vue";
import VisualizarNotificacao from "./VisualizarNotificacao.vue";

@Component({
  components: {
    ComboTipoNotificacao,
    ComboTipoEnvioNotificacao,
    DataTable,
    Tooltip,
    Confirm,
    Manter,
    VisualizarNotificacao,
    Detalhes,
  },
  filters: { dateTime, statusNotificacao, publicoNotificacao },
})
export default class CentralNotificacoes extends mixins(GlobalMixin) {
  tab: string | null = null;

  filtro: FiltroCentralNotificacoes = {
    idTipo: null,
    tipoEnvio: null,
    term: "",
    offset: 0,
    limit: 100,
    order: "",
  };

  promise: Promise<Notificacao[]> | null = null;

  headers = [
    { value: "data", text: "Data" },
    { text: "Notificação", align: "start", value: "titulo" },
    { value: "tipoNotificacao.nome", text: "Tipo" },
    { value: "publico", text: "Público" },
    { value: "enviadoPara", text: "Enviado Para" },
    { value: "status", text: "Status" },
    { value: "actions", text: "Ações", sortable: false },
  ];

  mounted() {
    this.filtro.term = "";
  }
  get tipoEnvioNotf() {
    return TipoEnvioNotificacao;
  }
  async excluirItem(item: Notificacao) {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Excluir notificação ${item.titulo}`;
    const text = `Deseja realmente excluir a notificação ${item.titulo} ?`;
    const res = await modalConfirm.open(title, text);
    if (res) {
      this.startLoader();
      await CentralNotificacoesService.excluirNotificacao(
        item.idNotificacao
      ).finally(this.stopLoader);
      this.fetchNotificacoes();
    }
  }
  async editarItem(item: Notificacao) {
    const modal = this.$refs.modalNotificacao as Manter;
    await modal.editarNotificacao(item.idNotificacao);
    this.fetchNotificacoes();
  }
  async visualizarItem(item: Notificacao) {
    const modalVisualizar = this.$refs.modalVisualizar as VisualizarNotificacao;
    await modalVisualizar.visualizarNotificacao(item.idNotificacao);
    this.fetchNotificacoes();
  }
  async comentarios(item: Notificacao) {
    this.$router.push({
      path: "/comentarios",
      query: {
        idNotificacao: item.idNotificacao.toString(),
        origem: "central",
      },
    });
  }

  async novoItem() {
    const modal = this.$refs.modalNotificacao as Manter;
    await modal.novaNotificacao();
    this.fetchNotificacoes();
  }
  fetchNotificacoes(options?: ServerPageOptions) {
    if (options) {
      Object.assign(this.filtro, options);
    }
    this.promise = CentralNotificacoesService.listarNotificacoes(this.filtro);
  }
}
